module.exports = __webpack_public_path__ + "img/1721783494381-WhatsApp Image 2024-07-24 at 09.06.21.jpeg.baca6601.webp";